<template>
    <div>
        <v-row>
            <v-col cols="12">
                <PletivoVigente @on-select-perlet="onSelectPerlet"/>
            </v-col>
            <v-divider class="my-2"></v-divider>
        </v-row>
        <v-row>
            <v-col cols="12" sm="12" md="12" v-show="!!computedConfigCodperlet">
                <div>
                    <label>Título Nova Lista:</label>
                    <v-text-field
                        placeholder="Nova Lista"
                        v-model="novaLista.titulo"
                        @keypress.enter="criarLista"
                        messages="Digite um título para criar uma nova lista"
                        clearable>
                        <template v-slot:append>
                            <v-btn @click="criarLista"> <v-icon>mdi-plus</v-icon> Criar </v-btn>
                        </template>
                    </v-text-field>
                </div>
            </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
        <v-row>
            <v-spacer></v-spacer>
            <v-btn @click="getListasPorPerlet" color="info"
                :loading="$store.state.checklistdb.loading_id === `get-checklists`">
                <v-icon>mdi-refresh</v-icon>
                Atualizar listas
            </v-btn>
        </v-row>
        <v-row>
            <v-col cols="12" v-for="l,i in computedListas" :key="i">
                <ItemListaPesquisa :item="l"
                    @on-click-item="onClickList(l)"
                    @on-updated="onItemUpdated"
                    @on-deleted="onItemDeleted"
                    />
            </v-col>
        </v-row>
        <pre v-show="false">{{checklists}}</pre>
        <!-- LISTA-->
        <modal-gdb code="modal_lista" dialog-width="100%" toolbar-title="Itens da Lista"
            ref="modal_lista">
            <template v-slot:activate-slot>
                <slot name="modal-activate">{{''}}</slot>
            </template>
            <template v-slot:body>
                <ItemListaSelecionada
                    :item="selectedLista"
                    @on-created="init"
                    @on-updated="onItemUpdated"
                    @on-deleted="onItemDeleted"/>
            </template>
        </modal-gdb>
        <loading-gdb :dialog="['get-checklists'].includes($store.state.checklistdb.loading_id)" text="Obtendo listas do período letivo..."/>
        <loading-gdb :dialog="['create-lista'].includes($store.state.checklistdb.loading_id)" text="Criando nova lista no período letivo..."/>
        <helper-gdb text="Lista" v-if="$store.getters.StateAuthenticatedUser.is_superuser"/>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import ItemListaPesquisa from './ItemListaPesquisa.vue'
import ItemListaSelecionada from './ItemListaSelecionada.vue'
import PletivoVigente from './PletivoVigente.vue'
export default {
    name: 'CheckListDBList',
    components: {
        ItemListaPesquisa, ItemListaSelecionada, PletivoVigente
    },
    data: () => ({
        selectedLista: {},
        search: '',
        novaLista: {
            titulo: null,
            codperlet: null
        },
        periodo_letivo: null,
        checklists:[]
    }),
    mounted() {
        this.init()
    },
    methods: {
        ...mapActions([
            // 'GetCheckListSettings',
            'GetCheckLists',
            'CreateCheckList',
            ]),
        async init(){
            // if(!this.computedConfigCodperlet){
            //     await this.GetCheckListSettings()
            // }
            if(this.computedConfigCodperlet){
                await this.getListasPorPerlet()
            }
        },
        async onSelectPerlet(value){
            this.periodo_letivo = value
            await this.getListasPorPerlet()
        },
        async criarLista(){
            if(!this.novaLista.titulo){
                alert('Nenhum título para a lista foi informado!')
                return
            }
            const confirma = confirm(`Confirma a criação de uma nova lista nomeada por ${this.novaLista.titulo} para o período letivo ${this.computedConfigCodperlet}?`)
            if(!confirma) return
            this.novaLista.codperlet = this.computedConfigCodperlet
            const created = await this.CreateCheckList(this.novaLista)
            if(!created) return
            await this.getListasPorPerlet()
            // limpar o formulário de material
            const novo = {
                titulo: null,
                codperlet: null
            }
            this.novaLista = Object.assign({}, novo)
        },
        getListasPorPerlet(){
            setTimeout(
                async ()=> {
                    const response = await this.GetCheckLists({codperlet: this.computedConfigCodperlet })
                    this.checklists = Object.assign([],response)
                }, 500
            )
        },
        onClickList(value){
            this.$refs.modal_lista.dialog = true
            this.selectedLista = value
        },
        onItemUpdated(){
            this.getListasPorPerlet()
        },
        onItemDeleted(){
            this.getListasPorPerlet()
        }
    },
    computed: {
        ...mapGetters([
            'StateCheckListPletivos',
            'StateCheckListMateriais',
            'StateDark'
        ]),
        computedListas(){
            // const listas = this.checklists
            // if (this.search){
            //     listas.value = listas.filter(o => o.titulo.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
            // }
            // return listas.value
            return this.checklists
        },
        computedConfigCodperlet(){
            // return this.$store.state.checklistdb.settings.codperlet
            return this.periodo_letivo
        }
    },
    watch: {
    }
}
</script>